import sidebars from './sidebars';
import main from './main';
import endpoints from './endpoints';
import { combineReducers } from 'redux';
import auth from './auth';
import messageBox from './messageBox';
import loader from './loader';
import customModal from './customModal';
import dateFilter from './dateFilter';
import userpreference from './userpreference'

//require('dotenv').config()

const eymio = combineReducers({
    sidebars,
    main,
    endpoints,
    auth,
    messageBox,
    loader,
    customModal,
    dateFilter,
    userpreference
})

export default eymio



// WEBPACK FOOTER //
// ./src/reducers/index.js